/**
 * Listens to our app channel for settings views being rendered.
 *
 * If we're rendering a datepicker setting, add our datepicker.
 * 
 * @package Ninja Forms builder
 * @subpackage Main App
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'controllers/fields/fieldDatepicker',[], function() {
	var controller = Marionette.Object.extend( {
		initialize: function() {
			this.listenTo( nfRadio.channel( 'setting-type-datepicker' ), 'render:setting', this.addDatepicker );
		},

		addDatepicker: function( settingModel, dataModel, view ) {
			//Switch to flatpickr from pikaday
			let el = jQuery( view.el ).find( '.setting' )[0];
			let datePickerSettings = {};
			nfRadio.channel( 'setting-type-datepicker' ).reply('get:options', () => { return dataModel.attributes });
			// Allow fields to add settings to the datepicker.
			let filteredDatePickerSettings = nfRadio.channel( 'setting-type-datepicker' ).request( 'filter:settings', datePickerSettings, settingModel, el );
			if ( 'undefined' != typeof filteredDatePickerSettings ) {
				datePickerSettings = filteredDatePickerSettings;
			}

			var dateObject = flatpickr( el, datePickerSettings );

			nfRadio.channel( 'setting-type-datepicker' ).trigger( 'loadComplete', dateObject, settingModel, dataModel, view );
		}
	});

	return controller;
} );
